import Repository from './Repository'

export default {
  get(payload) {
    return Repository.get('/banners', payload)
  },
  post(payload) {
    return Repository.post('/banners', payload)
  },
  detail(id) {
    return Repository.get('/banners/' + id)
  },
  put(payload) {
    return Repository.put('/banners/' + payload.id, payload)
  },
  delete(id) {
    return Repository.delete('/banners/' + id)
  }
}
